import { IncentiveIppAchievementValueAction } from '../enums/incentive-ipp-achievement-value-action.enum';

export class IncentiveIppRecordAssignment {
  assignmentId: string;
  gid: string;
  firstName: string;
  lastName: string;
  planName: string;
  startDate: string;
  endDate: string;
  ippAchievementValue: number;
  action: IncentiveIppAchievementValueAction;

  constructor(data?: Partial<IncentiveIppRecordAssignment>) {
    Object.assign(this, data);
  }

  public getExcelExportData(): object {
    return {
      action: this.action ?? IncentiveIppAchievementValueAction.NoAction,
      assignmentId: this.assignmentId,
      gid: this.gid,
      firstName: this.firstName,
      lastName: this.lastName,
      planName: this.planName,
      startDate: this.startDate,
      endDate: this.endDate,
      ippAchievementValue: this.ippAchievementValue
    };
  }
}

export interface IncentiveIppRecordAssignmentUploadDto {
  author: string;
  ippValues: Partial<IncentiveIppRecordAssignment>[];
}
